import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../../../contexts/AuthContext';
import { useErrorMessage } from '../../../../../utils/errorMessage';

const { TextArea } = Input;

export const CommentModal = ({
  supervisionId,
  comment,
  isModalOpen,
  setIsModalOpen,
  refreshData,
  setRefreshData
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isModalOpen) form.setFieldsValue({ comment });
  }, [isModalOpen, comment]);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      const { comment: newComment } = await form.validateFields();
      await dispatchAPI('PATCH', {
        url: `/supervisions/${supervisionId}/comment`,
        body: { comment: newComment }
      });
      setIsModalOpen(false);
      setRefreshData(!refreshData);
    } catch (error) {
      message(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      title={t('supervisions.show.modal.title.comment')}
      open={isModalOpen}
      onOk={handleSubmit}
      onCancel={() => setIsModalOpen(false)}
      okText={t('buttons.save')}
      cancelText={t('buttons.cancel')}
      confirmLoading={isSubmitting}
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item name="comment">
          <TextArea autoSize={{ minRows: 4 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

CommentModal.propTypes = {
  supervisionId: PropTypes.string.isRequired,
  comment: PropTypes.string,
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  refreshData: PropTypes.bool.isRequired,
  setRefreshData: PropTypes.func.isRequired
};

CommentModal.defaultProps = {
  comment: ''
};
